(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var ProductSystem = (function () {
  function ProductSystem(products, options) {
    _classCallCheck(this, ProductSystem);

    this.products = products;
    this.productOptions = this._serializeOptions();
    this.dependencies = this._dependencies();
    this.customerLevel = $('#customer-level').val();

    this._init();
  }

  _createClass(ProductSystem, [{
    key: '_init',
    value: function _init() {
      if (!isNaN(this.colorOptionsKey)) {
        this._renderColorOptions();
      }

      this._renderSelectOptions();

      //First Handle Change
      (function (obj) {
        return $(document).ready(function () {
          return obj.handleChange();
        });
      })(this);
    }
  }, {
    key: '_dependencies',
    value: function _dependencies() {
      var _this = this;

      var optionsLength = this.productOptions.length;
      var mainOption = undefined;
      var optionsList = [];

      var colorOptions = _.find(this.productOptions, function (obj) {
        return obj.option == 'Color';
      });
      this.colorOptionsKey = colorOptions ? colorOptions.key : undefined;

      if (optionsLength > 1) {
        this.mainOption = colorOptions ? this.productOptions[this.colorOptionsKey] : this.productOptions[0];

        this.mainOption.variations.forEach(function (variation) {
          var obj = {};

          obj.name = variation;
          obj.products = _.filter(_this.products, function (obj) {
            return obj.options[_this.mainOption.key] == variation;
          });
          obj.variations = _this._serializeOptions(obj.products);

          optionsList.push(obj);
        });
      }

      return optionsList;
    }
  }, {
    key: '_serializeOptions',
    value: function _serializeOptions(products) {
      products = products || this.products;

      return _.map(productOptions, function (option, key) {

        var variations = _.map(products, function (product) {
          return product.options[key];
        });

        variations = _.uniq(variations);

        return {
          option: option, key: key, variations: variations
        };
      });
    }
  }, {
    key: 'getVariation',
    value: function getVariation() {
      var options = [],
          optionName = '',
          option = undefined;

      // Collect options values
      for (var i = 0; i < productOptions.length; i++) {
        options.push($('[data-option-id="' + i + '"]:checked').val());
      }

      // Prepare option name
      for (var i = 0; i < options.length; i++) {
        optionName = optionName + options[i];

        if (i !== options.length - 1) {
          optionName = optionName + ' / ';
        }
      }

      // Find option by option name
      option = _.find(this.products, function (obj) {
        return obj.title == optionName;
      });

      return option;
    }
  }, {
    key: '_renderColorOptions',
    value: function _renderColorOptions() {
      var _this2 = this;

      var variations = this.productOptions[this.colorOptionsKey].variations;
      var $element = $('<div />');
      var customerLevel = parseInt(this.customerLevel);
      var wholesaleVariantsExist = variations.reduce(function (is_wholesale, variant) {

        if (typeof is_wholesale !== "boolean") {
          is_wholesale = false;
        }

        switch (customerLevel) {
          case 1:
            if (variant.indexOf('(sw)') > 0) {
              is_wholesale = true;
            }
            break;
          case 2:
            if (variant.indexOf('(mw)') > 0) {
              is_wholesale = true;
            }
            break;
          case 3:
            if (variant.indexOf('(lw)') > 0) {
              is_wholesale = true;
            }
            break;
          default:
            // console.log( 'default case');
            break;
        }

        return is_wholesale;
      });

      for (var i = 0; i < variations.length; i++) {
        var $variant = $('\n        <label class="option-color" data="' + variations[i] + '" for="' + variations[i] + '" title="' + variations[i] + '">\n        </label>\n      ');

        var $input = $('\n        <input type="radio" value="' + variations[i] + '" data-option-id="' + this.colorOptionsKey + '" data-index="' + i + '" name="Color" id="' + variations[i] + '"/>\n      ');

        if (i === 0) {
          $input.prop('checked', true);
        }

        $input.on('change', function (event) {
          _this2.handleChange(event.target);
        });

        if (customerLevel > 0) {
          // show only wholesale variants
          if (customerLevel == 1 && variations[i].indexOf('(sw)') > 0) {
            $element.append($input);
            $element.append($variant);
            continue;
          } else if (customerLevel == 2 && variations[i].indexOf('(mw)') > 0) {
            $element.append($input);
            $element.append($variant);
            continue;
          } else if (customerLevel == 3 && variations[i].indexOf('(lw)') > 0) {
            $element.append($input);
            $element.append($variant);
            continue;
          } else {
            // if ( wholesaleVariantsExist === true) {
            //   continue;
            // }       
            // hide wholesale variants
            if (variations[i].indexOf('(sw)') > 0 || variations[i].indexOf('(mw)') > 0 || variations[i].indexOf('(lw)') > 0) {
              continue;
            }
            // Show regular variant if wholesale variants don't exist
            $element.append($input);
            $element.append($variant);
          }
        } else {
          // hide wholesale variants
          if (variations[i].indexOf('(sw)') > 0 || variations[i].indexOf('(mw)') > 0 || variations[i].indexOf('(lw)') > 0) {
            continue;
          }
          $element.append($input);
          $element.append($variant);
        }
      }

      $('.product-option.color').append($element);
    }
  }, {
    key: '_renderSelectOptions',
    value: function _renderSelectOptions(index) {
      var _this3 = this;

      var options = [];

      if (this.productOptions.length > 1) {
        options = index !== undefined ? this.dependencies[index].variations : this.dependencies[0].variations;
      } else {
        options = this.productOptions;
      }

      var $optionsList = $('.product-select-options');

      $optionsList.empty();

      for (var i = 0; i < options.length; i++) {

        if (i !== this.colorOptionsKey) {
          var variations = options[i].variations,
              $option = $('\n              <div class="select-wrapper">\n                <h4 class="label" for="' + options[i].key + '">Choose ' + options[i].option + ':</h4>\n                <select data-option-id="' + options[i].key + '" name="' + options[i].option + '"> </select>\n              </div>\n            '),
              $select = $option.find('select'),
              key = options[i].key;

          for (var _i = 0; _i < variations.length; _i++) {
            var variation = variations[_i];

            var _$option = $('\n            <option value="' + variation + '" data-option-id="' + key + '"> ' + variation + ' </option>\n          ');

            $select.append(_$option);
          }

          $select.change(function (event, object) {
            _this3.handleChange(event.target);
          });

          $optionsList.append($option);
        }
      }
    }
  }, {
    key: 'preparePrice',
    value: function preparePrice(price) {
      var lastTwo = price.toString().substr(-2);
      price = '$' + price.toString().slice(0, -2);

      if (lastTwo !== '00') {
        price = price + '.' + lastTwo;
      }
      return price;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(target) {
      $(window).trigger('productOptionChange', [this, target]);
    }
  }]);

  return ProductSystem;
})();

exports['default'] = ProductSystem;
module.exports = exports['default'];

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var RecentlyProducts = (function () {
  function RecentlyProducts(product) {
    _classCallCheck(this, RecentlyProducts);

    this.currentProduct = product;
    this.productsList = this._getData();
    this.currentProductIndex = this._getProductIndex();

    this._setData();
  }

  _createClass(RecentlyProducts, [{
    key: '_getData',
    value: function _getData() {
      var data = localStorage.recentlyProducts;

      data = data ? JSON.parse(data) : [];

      return data;
    }
  }, {
    key: '_getProductIndex',
    value: function _getProductIndex() {
      var index = false;
      for (var i = 0; i < this.productsList.length; i++) {
        if (this.currentProduct.title == this.productsList[i].title) {
          index = i;

          break;
        }
      }
      return index;
    }
  }, {
    key: '_setData',
    value: function _setData() {

      if (this.currentProductIndex !== false) {
        this.productsList.splice(this.currentProductIndex, 1);
      }

      this.productsList.push(this.currentProduct);

      localStorage.recentlyProducts = JSON.stringify(this.productsList);
    }
  }, {
    key: 'getProducts',
    value: function getProducts() {
      return this.productsList;
    }
  }, {
    key: 'renderProducts',
    value: function renderProducts() {
      var pr = this.productsList,
          $container = $('.recently-viewed .list');
      if (pr.length) {
        for (var i = 0; i < 8; i++) {
          if (typeof pr[i] != "undefined") {
            var $link = $('<a></a>').addClass('product-thumb product-thumb-sm').attr('href', pr[i].url).attr('title', pr[i].title),
                $figure = $('<figure></figure>').addClass('transp-bg'),
                $image = $('<img />').attr('src', pr[i].image).attr('alt', pr[i].title);

            $figure.append($image);
            $link.append($figure);

            $container.append($link);
          }
        }
      }
    }
  }]);

  return RecentlyProducts;
})();

exports['default'] = RecentlyProducts;
module.exports = exports['default'];

},{}],3:[function(require,module,exports){
'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pagesProductPage = require('./pages/product-page');

var _pagesProductPage2 = _interopRequireDefault(_pagesProductPage);

/* Main Scripts */
(function ($) {
	$.flo = {
		elements: {
			w: $(window),
			b: $('body'),
			h: $('.header-main')
		},
		helpers: {
			goto: function goto(element) {
				$('body,html').animate({
					scrollTop: element.offset().top
				}, 800);
			}
		}
	};

	$('.goto').click(function (e) {
		var scrollToEl = $(this).data('href');

		if (scrollToEl === undefined) {
			scrollToEl = '#' + $(this).parents('.row').next('.row').attr('id');
		}
		$.flo.helpers.goto($(scrollToEl));

		return false;
	});

	$('.play-media').magnificPopup({
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
		iframe: {
			patterns: {
				youtube_short: {
					index: 'youtu.be/',
					id: 'youtu.be/',
					src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
				}
			}
		}
	});

	$('.btn-mobile-menu').click(function (event) {
		event.preventDefault();

		$('.btn-mobile-menu').toggleClass('active');
		$('.header-main').toggleClass('show-menu');
	});

	$.fn.shuffle = function () {
		var j;
		for (var i = 0; i < this.length; i++) {
			j = Math.floor(Math.random() * this.length);
			$(this[i]).before($(this[j]));
		}
		return this;
	};

	$.fn.init_home = function () {
		$(this).each(function () {
			var homePage = $(this);
			var collectionsList = homePage.find('.collections-list');
			var previewId;

			$('.stories-slider', homePage).slick({
				arrows: true,
				appendArrows: false,
				dots: false,
				infinite: false,
				speed: 500,
				cssEase: 'linear',
				slidesToShow: 2,
				slidesToScroll: 2,
				// variableWidth: true,
				// mobileFirst: true,
				prevArrow: '.prev-story',
				nextArrow: '.next-story',
				responsive: [{
					breakpoint: 640,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}]
			});

			$('.collection-link', homePage).click(function () {
				if ($(this).hasClass('view-all')) {
					return true;
				} else if ($(this).hasClass('active-tab')) {
					return false;
				} else {
					collectionsList.find('.active-tab').removeClass('active-tab');
					$(this).addClass('active-tab');
					previewId = '#' + $(this).data('id');
					$(previewId).addClass('active-preview').siblings().removeClass('active-preview');
					$(previewId).animate({
						opacity: 1
					}, 330);
				}
				return false;
			}).first().trigger('click');
		});
	};
	$('.template-index, .template-home').init_home();

	$.fn.init_account = function () {
		$(this).each(function () {
			$('.forgot-passw').click(function () {
				$('.recover-account').slideToggle();
			});

			if (window.location.hash == '#recover') {
				$('.recover-account').slideDown();
			}
		});
	};
	$('.account-box').init_account();

	$.fn.init_community = function () {
		$(this).each(function () {
			var communityPage = $(this);
			var artistSpotlight = communityPage.find('.artist-spotlight');

			$('.list-toggler', communityPage).click(function () {
				artistSpotlight.toggleClass('expanded-list');
				$(this).toggleClass('expanded-list');

				if ($(this).hasClass('expanded-list')) {
					$(this).text('Close list');
				} else {
					$(this).text('Expand list');
				}
				return false;
			});
		});
	};
	$('.page-template-template-community').init_community();

	$.fn.init_collections = function () {
		$(this).each(function () {
			var collectionsPage = $(this);
			var subnavToggler = $('.subnav-toggler', collectionsPage);
			var collectionsArray = $('.collections-array', collectionsPage);

			$('a', subnavToggler).click(function () {
				var fn = $(this);
				if (fn.hasClass('active-tab')) {
					return false;
				} else if (fn.hasClass('show-grid')) {
					collectionsArray.addClass('collections-grid').removeClass('collections-list');
				} else {
					collectionsArray.addClass('collections-list').removeClass('collections-grid');
				}
				fn.addClass('active-tab').siblings().removeClass('active-tab');
				return false;
			});
		});
	};
	$('body.template-list-collections').init_collections();

	$.fn.init_collections_lookbook = function () {
		$(this).each(function () {
			var collectionsLookbook = $(this);

			$('.play-video').magnificPopup({
				disableOn: 700,
				type: 'iframe',
				mainClass: 'mfp-fade',
				removalDelay: 160,
				preloader: false,
				fixedContentPos: false,
				iframe: {
					patterns: {
						youtube_short: {
							index: 'youtu.be/',
							id: 'youtu.be/',
							src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
						}
					}
				}
			});
			imagesLoaded('.collection-lookbook', function () {
				$('.collection-lookbook', collectionsLookbook).masonry({
					itemSelector: '.lbthumb'
				});
			});

			$('.story', collectionsLookbook).fitVids();
		});
	};
	$('.single-lookbook').init_collections_lookbook();

	$.fn.initCommentReply = function () {
		var fn = $(this);
		fn.find('.comment-reply-link').on('click', function () {
			var reply = $(this);
			var comment_id = reply.attr('id').replace('reply-link-', '');

			fn.find('#comment_parent').val(comment_id);

			var name = $('#author-' + comment_id + ' a').html() ? $('#author-' + comment_id + ' a').html() : $('#author-' + comment_id).html();
			fn.find('.reply-to-name').html(name);
			fn.find('.reply-to').show();
			$('body,html').animate({
				scrollTop: $('div.comment-form').offset().top - 100
			}, 550);
		});
		return false;
	};

	$.fn.initCancelReply = function () {
		var fn = $(this);
		fn.find('.reply-to > a').click(function () {
			fn.find('#comment_parent').val('0');
			fn.find('.reply-to-name').html('');
			fn.find('.reply-to').hide();
		});
	};

	$.fn.clearReply = function () {
		var fn = $(this);
		fn.find('#comment_parent').val('0');
		fn.find('.reply-to-name').html('');
		fn.find('.reply-to').hide();
	};

	$.fn.init_single_post = function () {

		var _validate_options = {
			rules: {
				author: {
					required: true
				},
				email: {
					required: true,
					email: true
				},
				comment: {
					required: true
				}
			}
		};

		_validate_options.submitHandler = function (_form) {
			var form = $(_form);
			var post = form.parents('.hentry');
			var comments = post.find('section.comments');

			var submitContainer = form.find('div.say');
			var messages = post.find('div.messages');
			var list = comments.find('.commentlist');

			form.ajaxSubmit({
				beforeSubmit: function beforeSubmit() {
					submitContainer.hide();
				},
				success: function success() {
					form.clearForm();
					submitContainer.fadeIn();
					list.load(flo.ajax_load_url, {
						'id': form.find('input[name=comment_post_ID]').val(),
						'action': 'flotheme_load_comments'
					}, function () {
						messages.hide().html('Thank you, kindly.  We love hearing what you have to say!').slideDown('fast');
						post.initCommentReply();
						post.initCancelReply();
						post.clearReply();
						post.find('.cancel-reply').trigger('click');
						setTimeout(function () {
							messages.slideUp('fast');
						}, 10000);
					});
				},
				error: function error(request) {
					var error = request.responseText.match(/<p>([^<]+)<\/p>/)[1];
					messages.hide().html(error).slideDown('fast');
					submitContainer.show();
				}
			});
		};

		$(this).each(function () {
			var singlePost = $(this);

			singlePost.initCommentReply();
			singlePost.initCancelReply();
			singlePost.clearReply();

			$('.com-counter').click(function () {
				$('body,html').animate({
					scrollTop: $('div.comment-form').offset().top - 100
				}, 550);
			});

			$('div.comment-form form', singlePost).validate(_validate_options);
			$('.story', singlePost).fitVids();
		});
	};
	$('body.single-post').init_single_post();

	if ($('body.template-product').length) {
		(0, _pagesProductPage2['default'])(productVariants, productOptions);
	}

	$.fn.init_cart = function () {

		var $updateWrapper = $('.row.cart .btn-update-wrapper');

		$(".product .qty").each(function (index, el) {
			var $block = $(this),
			    $input = $block.find('input[type="text"]');

			$block.find('.nav').click(function (event) {
				event.preventDefault();

				var inputValue = parseInt($input.val());

				if (isNaN(inputValue)) {
					inputValue = 1;
				}

				if ($(this).data('ac') == 'up') {
					inputValue = inputValue + 1;
				} else if ($(this).data('ac') == 'down') {
					if (inputValue !== 1) {
						inputValue = inputValue - 1;
					}
				}

				$input.val(inputValue);

				if (!$updateWrapper.hasClass('active')) {
					$updateWrapper.slideDown().addClass('active');
				}
			});
		});
	};

	$('#your-shopping-cart, .template-cart').init_cart();

	$.fn.init_shopgrid = function () {
		$(this).each(function () {
			var shopGrid = $(this);

			var columnsToggler = $('.columns-toggler', shopGrid);
			var productsArray = $('.products-array', shopGrid);
			var collectionUrl = window.location.origin + window.location.pathname;

			$('a', columnsToggler).click(function () {
				var fn = $(this);
				if (fn.hasClass('active-tab')) return false;

				if (fn.hasClass('show-2col')) {
					productsArray.addClass('columns-2').removeClass('columns-4 columns-3');
				} else if (fn.hasClass('show-3col')) {
					productsArray.addClass('columns-3').removeClass('columns-4 columns-2');
				} else {
					productsArray.addClass('columns-4').removeClass('columns-3 columns-2');
				}
				fn.addClass('active-tab').siblings().removeClass('active-tab');
				return false;
			});

			$.flo.elements.w.on('resize', function () {
				if ($.flo.elements.w.outerWidth() <= 768) {
					columnsToggler.find('.show-2col').trigger('click');
				} else if ($.flo.elements.w.outerWidth() < 860) {
					columnsToggler.find('.show-3col').trigger('click');
				} else {
					columnsToggler.find('.show-4col').trigger('click');
				}
			});

			$('#price-range').ddslick({
				width: 132,
				selectText: "Price",
				onSelected: function onSelected(data) {
					window.location = collectionUrl + data.selectedData.value;
				}
			});
			$('#product-tags').ddslick({
				width: 132,
				selectText: "Type",
				onSelected: function onSelected(data) {
					window.location = data.selectedData.value;
				}
			});
		});
	};
	$('body.template-collection').init_shopgrid();

	$.fn.init_faq = function () {
		$(this).each(function () {
			var faqArchive = $(this),
			    currentTopic,
			    currentTopicClass,
			    faqArchiveList = faqArchive.find('.faq-archive-list'),
			    faqTopicsList = faqArchive.find('.faq-topics-list');

			var listSearchOptions = {
				searchClass: 'search-faq',
				listClass: 'faq-archive-list',
				valueNames: ['faq-question', 'faq-answer']
			};
			var faqList = new List('content', listSearchOptions);

			var noItems = $('<li class="no-items-found">No results</li>');

			faqList.on('updated', function (list) {
				if (list.matchingItems.length === 0) {
					$(list.list).append(noItems);
				} else {
					noItems.detach();
				}
			});

			$('.faq-topic-link').click(function () {
				currentTopic = $(this);

				if (currentTopic.hasClass('real-link')) {
					return true;
				}

				if (!currentTopic.hasClass('active-topic')) {
					faqTopicsList.find('a').removeClass('active-topic');
					currentTopic.addClass('active-topic');
					currentTopicClass = '.faq-type-' + currentTopic.data('id');
					$('.search-faq').val('');
					faqList.search();
					faqArchiveList.find('li').fadeOut();
					faqArchiveList.find(currentTopicClass).fadeIn();
				}
				return false;
			});
		});
	};

	$('.page-template-template-faq').init_faq();

	$.fn.init_news_archive = function () {
		$(this).each(function () {
			var newsArchive = $(this);

			imagesLoaded(newsArchive, function () {
				newsArchive.masonry({
					itemSelector: '.news-preview'
				});
			});
		});
	};

	$('.news-archive').init_news_archive();

	$.flo.elements.w.trigger('resize');

	$.fn.responsivePressKitBanner = function () {
		$(this).each(function () {
			var $img = $(this);
			// $img.css('max-width', $img.width()/2);
			$.flo.elements.w.load(function () {
				$img.css('max-width', $img.width() / 2);
			});
		});
	};

	$('.presskit-wrapper--banners .banners img', '.page-template-template-press-kit-php').responsivePressKitBanner();
})(jQuery);

},{"./pages/product-page":4}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ClassProductSystem = require('../ClassProductSystem');

var _ClassProductSystem2 = _interopRequireDefault(_ClassProductSystem);

var _ClassRecentlyProducts = require('../ClassRecentlyProducts');

var _ClassRecentlyProducts2 = _interopRequireDefault(_ClassRecentlyProducts);

exports['default'] = function (productVariants, productOptions) {
  var product = $(this);
  var $bigSlider = $('.product-main .big-slider'),
      $thumbnails = $('.product-main .thumbnails');

  $bigSlider.slick({
    arrows: false,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 6000,
    initialSlide: 0
  });

  $(window).on('load', function () {
    $thumbnails.jScrollPane({
      verticalDragMaxHeight: 34
    });

    $thumbnails.on('click', '.thumbnail', function (event) {
      event.preventDefault();
      $bigSlider.slick('slickGoTo', $(event.currentTarget).index());
    });
  });

  /**
   * @type {ProductSystem}
   -------------------------------------------------------------------------*/
  var products = new _ClassProductSystem2['default'](productVariants, productOptions);

  var $thumbnailItems = $thumbnails.find('.thumbnail'),
      $thumbnailsWrapper = $thumbnails.find('.thumbnails-wrapper');

  $(window).on('productOptionChange', function (event, priceObject, target) {
    var index = 0;
    var isMainOption = false;

    if (target) {
      index = $(target).data('index');

      if (priceObject.productOptions.length > 1) {
        isMainOption = $(target).data('option-id') == priceObject.mainOption.key;
      }

      if (isMainOption) {
        priceObject._renderSelectOptions(index);
      }
    }

    var option = priceObject.getVariation();
    console.log(option);
    var available = option ? true : false;
    var inStock = option && option.available;
    var sale = option && option.compare_at_price ? true : false;
    var price = option ? priceObject.preparePrice(option.price) : false;

    if (available) {
      $('.product-sku label').html(option.sku);
    }

    $('.block.buy-button').attr('data-available', available);
    $('.block.buy-button').attr('data-in-stock', inStock);

    $('.price-block').attr('data-sale', sale).attr('data-is-price', price);

    var thereIsOption = false;

    for (var i = 0; i < productImages.length; i++) {
      var _index = productImages[i].alt.indexOf(option.sku);

      if (_index >= 0) {
        thereIsOption = true;

        break;
      }
    }

    if (thereIsOption) {
      var skuFilter = function skuFilter(index, element) {
        var data = $(element).data('color').split('/');
        data = _.last(data).replace(/ /g, '').split(',');

        return _.contains(data, option.sku);
      };

      $bigSlider.slick('slickFilter', skuFilter);
      $bigSlider.slick('slickGoTo', 0);

      var $filteredThumbs = $thumbnailItems.filter(skuFilter);

      $thumbnailsWrapper.empty();
      $thumbnailsWrapper.append($filteredThumbs);

      var jsp = $thumbnails.data('jsp');

      if (jsp) {
        jsp.reinitialise();
      }

      var $input = $('input[data-option-id="' + priceObject.colorOptionsKey + '"]:checked');

      if ($input.length) {
        $('.current-color-name').html($input.val());
      }
    } else if (priceObject.colorOptionsKey || priceObject.colorOptionsKey === 0) {
      (function () {

        var $input = $('input[data-option-id="' + priceObject.colorOptionsKey + '"]:checked'),
            color = $input.val();

        $('.current-color-name').html(color);

        if (priceObject.colorOptionsKey === 0) {
          var colorFilter = function colorFilter(index, element) {
            var imageColor = $(element).data('color');
            var n = color.indexOf('/');

            n = n != -1 ? n : color.length;

            imageColor = imageColor.substring(0, n);

            return imageColor == color ? true : false;
          };

          $bigSlider.slick('slickFilter', colorFilter);

          $bigSlider.slick('slickGoTo', 0);

          var $filteredItems = $thumbnailItems.filter(colorFilter);

          $thumbnailsWrapper.empty();
          $thumbnailsWrapper.append($filteredItems);

          var jsp = $thumbnails.data('jsp');

          if (jsp) {
            jsp.reinitialise();
          }
        }
      })();
    } else if (option && option.featured_image) {
      var re = /(https:)([^\?]+)\.(jpe?g|jpe|gif|png)(\?.*)$\b/i;
      var str = option.featured_image.src;
      var subst = '$2';

      var findUrl = str.replace(re, subst);

      var $slide = $('.big-slider').find('img[src^="' + findUrl + '"], img[data-lazy ^="' + findUrl + '"]').parent();

      $('.big-slider').slick('slickGoTo', $slide.index());
    }

    if (available) {
      $('#product-id').val(option.id);
    }

    if (price) {
      $('.price-block span.price').html(price);
    }

    if (sale) {
      var savePrice = option.compare_at_price - option.price;
      var procent = (savePrice / option.compare_at_price * 100).toFixed(0).toString() + '%';

      $('.compare-price').html(this._preparePrice(option.compare_at_price));
      $('.discount-disclaimer .save').html(this._preparePrice(savePrice));

      $('.discount-disclaimer .sale').html(procent);
    }
  });
  /*------------------------------------------------------------------------------*/

  $('.you-may-like .list a').shuffle();
  $('.you-may-like .list').animate({
    opacity: 1
  }, '1000', function () {});

  $(".actions .block.quantity").each(function (index, el) {
    var $block = $(this),
        $input = $block.find('input[type="text"]');

    $block.find('.nav').click(function (event) {
      event.preventDefault();

      var inputValue = parseInt($input.val());

      if (isNaN(inputValue)) {
        inputValue = 1;
      }

      if ($(this).data('ac') == 'up') {
        inputValue = inputValue + 1;
      } else if ($(this).data('ac') == 'down') {
        if (inputValue !== 1) {
          inputValue = inputValue - 1;
        }
      }

      $input.val(inputValue);
    });
  });

  $('.reviews-slider', product).on('init', function (event, slick) {
    $('span.total-slide').text(slick.slideCount);
  });

  setTimeout(function () {
    $('.spr-reviews').slick({
      arrows: true,
      dots: false,
      infinite: false,
      adaptiveHeight: true
    });
  }, 2000);

  $(window).load(function () {

    setTimeout(function () {
      if (!$('.spr-reviews .spr-review').length) {
        $('.spr-form').show();

        $('.spr-summary-actions-newreview').click(function (event) {
          event.preventDefault();
          event.stopPropagation();
        });
      }
    }, 1000);
  });

  $.fn.floTabs = function () {
    var $tabBlock = $(this),
        $nav = $tabBlock.find('.tab-navs'),
        $tabs = $tabBlock.find('.tab-content');

    $nav.find('.tab-nav').click(function (event) {
      event.preventDefault();

      if (!$(this).hasClass('active')) {
        $tabs.find('.active').removeClass('active');
        $nav.find('.active').removeClass('active');

        $tabs.find('.tab').eq($(this).index()).addClass('active');

        $(this).addClass('active');
      }
    });
  };

  $('.tabs').floTabs();

  $('.tab').fitVids();

  var recentlyProducts = new _ClassRecentlyProducts2['default']({
    title: $('h2[itemprop="name').html(),
    url: $('meta[itemprop="url"').attr('content'),
    image: $('meta[itemprop="image"]').attr('content')
  });

  if (window.location.hostname !== 'localhost') {
    recentlyProducts.renderProducts();
  }
};

module.exports = exports['default'];

},{"../ClassProductSystem":1,"../ClassRecentlyProducts":2}]},{},[3]);
